(() => {
  if (window.kp49UIReady) return;
  window.kp49UIReady = true;
  document.addEventListener('click', event => {
    document.querySelectorAll('.kp49-menu[open]').forEach(menu => {
      if (!menu.contains(event.target)) menu.open = false;
    });
    const button = event.target.closest('[data-kp49-offer]');
    if (!button) return;
    const root = document.querySelector('shopify-forms-embed#app-embed-container-1178935')?.shadowRoot;
    const teaser = root?.querySelector('button[data-testid="form-teaser"]');
    const dialog = root?.querySelector('[role="dialog"]');
    if (dialog && dialog.getClientRects().length) {
      dialog.querySelector('input[type="email"]')?.focus();
    } else if (teaser && !teaser.disabled && teaser.getClientRects().length) {
      teaser.click();
    } else {
      const help = document.getElementById(button.getAttribute('aria-describedby'));
      if (help) help.hidden = false;
    }
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.kp49-menu[open]').forEach(menu => {
      const focused = menu.contains(document.activeElement);
      menu.open = false;
      if (focused) menu.querySelector('summary').focus();
    });
  });
})();
